import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptAppBrands } from "../../adapters/adaptAppBrands";

const fetchAppBrandLibrary = async () => {
	const url = "/homepage/admin/app-branding/";

	const response = await cmsClient.get<IAppBrand[]>(url, {
		params: {
			published: false,
		},
	});

	return response.data;
};

const useAppBrandLibrary = () => {
	const query = useQuery(["app-brand-library"], fetchAppBrandLibrary, {
		select: adaptAppBrands,
	});

	return query;
};

export default useAppBrandLibrary;
